import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined, SendOutlined } from '@ant-design/icons';
import { login } from '../services/api';
import './Login.css';

const { Title } = Typography;

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { username, password } = values;
      const result = await login(username, password);
      message.success('登录成功！');
      onLogin(result.user, result.token);
    } catch (error) {
      console.error('登录错误:', error);
      message.error(error.message || '网络错误，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background"></div>
      <div className="login-shell">
        
        <Card className="login-card">
          <div className="login-header">
            <div className="login-logo">
              <SendOutlined style={{ fontSize: 28, color: '#fff', transform: 'rotate(-45deg)' }} />
            </div>
            <Title level={2} className="login-title">
              羽毛球场地预约系统
            </Title>
            <p className="login-subtitle">管理员登录</p>
          </div>

          <Form
            name="login"
            className="login-form"
            onFinish={onFinish}
            autoComplete="off"
            size="large"
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: '请输入用户名！',
                },
              ]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="用户名"
                className="login-input"
                autoComplete="username"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: '请输入密码！',
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder="密码"
                className="login-input"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={loading}
                block
              >
                登录
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
      <div className="login-footer">© {new Date().getFullYear()} 场地预约系统</div>
    </div>
  );
};

export default Login; 
